import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../../services/apiServices';
 

// Async thunks for API calls
export const fetchReportedIssues = createAsyncThunk('reportedIssues/fetchReportedIssues', async () => {
  const response = await apiService.get('reported-issues');
  return response.data;
});

export const createReportedIssue = createAsyncThunk('reportedIssues/createReportedIssue', async (issueData) => {
  const response = await apiService.post('reported-issues', issueData);
  return response.data;
});

export const updateReportedIssue = createAsyncThunk('reportedIssues/updateReportedIssue', async ({ id, issueData }) => {
  const response = await apiService.put(`reported-issues/${id}`, issueData);
  return response.data;
});

export const deleteReportedIssue = createAsyncThunk('reportedIssues/deleteReportedIssue', async (id) => {
  await apiService.delete(`reported-issues/${id}`);
  return id;
});

// Initial state
const initialState = {
  reportedIssues: [],
  loading: false,
  error: null,
};

// Reported Issues slice
const reportedIssuesSlice = createSlice({
  name: 'reportedIssues',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReportedIssues.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReportedIssues.fulfilled, (state, action) => {
        state.loading = false;
        state.reportedIssues = action.payload;
      })
      .addCase(fetchReportedIssues.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createReportedIssue.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createReportedIssue.fulfilled, (state, action) => {
        state.loading = false;
        state.reportedIssues.push(action.payload);
      })
      .addCase(createReportedIssue.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updateReportedIssue.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateReportedIssue.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.reportedIssues.findIndex((issue) => issue._id === action.payload._id);
        if (index !== -1) {
          state.reportedIssues[index] = action.payload;
        }
      })
      .addCase(updateReportedIssue.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(deleteReportedIssue.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteReportedIssue.fulfilled, (state, action) => {
        state.loading = false;
        state.reportedIssues = state.reportedIssues.filter((issue) => issue._id !== action.payload);
      })
      .addCase(deleteReportedIssue.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default reportedIssuesSlice.reducer;